import React from 'react';
import type ProductsJswStorageManagementType from '@atlassian/jira-spa-apps-products-jsw-storage-management/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJswStorageManagement = lazyForPaint<
	typeof ProductsJswStorageManagementType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsw-storage-management", jiraSpaEntry: "async-products-jsw-storage-management" */ '@atlassian/jira-spa-apps-products-jsw-storage-management'
		),
	),
);

const AsyncProductsJswStorageManagement = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJswStorageManagement}
		pageId="products-jsw-storage-management"
		shouldShowSpinner
	/>
);

export default AsyncProductsJswStorageManagement;
